/* eslint-disable no-undef */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment } from "react";
import Modal from "react-modal";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import icon_close__white from "../../assets/icons/icon-close--white.svg";
import icon_card from "../../assets/icons/icon-card.svg";
import icon_calendar from "../../assets/icons/icon-calendar.svg";
import icon_lock__white from "../../assets/icons/icon-lock--white.svg";
import icon_user__white from "../../assets/icons/icon-user--white.svg";
import InputMask from "react-input-mask";
import { useSubscriptionContext } from "../../context/providers/SubscriptionContext";
import PhoneInput from "react-phone-input-2";
import startsWith from "lodash.startswith";
import axios from "axios";
import socketIOClient from "socket.io-client";
import "react-phone-input-2/lib/bootstrap.css";
import OverlayLoader from "react-fullpage-custom-loader";
import referenceGenerator from "../../utils/referenceGenerator";
import { showInfoMessage } from "../../utils/notification";

const CardModal = ({ activeModal, closeModal, user, modalStylesReset, card, setActiveModal, isValid }) => {
	const {
		createSubscription,
		updateCard,
		getGateway,
		gateways,
		finalizeTransaction,
		clearGateway,
	} = useSubscriptionContext();
	/**Card section======================== */
	const [cardData, setCardData] = React.useState({
		number: "",
		expires: "",
		cvc: "",
	});
	const { number, expires, cvc } = cardData;
	const handleCardDataChange = (e) => {
		setCardData({ ...cardData, [e.target.name]: e.target.value });
	};
	//Handle card form   submission
	const handleFormSubmit = (e) => {
		e.preventDefault();
		closeModal();
		const arr = expires.split("/").map(Number);
		const data = {
			card: {
				number: number,
				exp_month: arr[0],
				exp_year: arr[1],
				cvc: cvc,
			},
			email: user.email,
			name: user.firstName + " " + user.lastName,
			user: user._id,
			amount: user.discount > 0 ? 16 : 20,
			paymentMethod: "CARD",
		};
		/// If current susbcription is valid then update just card else create new one
		if (isValid) {
			updateCard(card._id, data);
		} else {
			createSubscription(data);
		}

		console.log(data);
	};
	/**========================= */

	/**Mobile payment section */
	const [gateway, setGateway] = React.useState("");
	const [showLoader, setShowLoader] = React.useState(false);

	const [phonenumber, setPhonenumber] = React.useState("");
	React.useEffect(() => {
		const socket = socketIOClient(process.env.REACT_APP_BACKEND_SERVER);
		socket.on("test", (data) => {
			console.log(data)
		});
		socket.on("MobilePaymentfromPaydunya", (data) => {
			console.log(`Payment succes from paydunya`)
			finalizeTransaction(localStorage.getItem("transaction_id"));
			setShowLoader(false);
			localStorage.removeItem("transaction_id");
			clearGateway();
		});
		socket.on("paymentCanceled", (data) => {
			console.log(data);
			setShowLoader(false);
			localStorage.removeItem("transaction_id");
			clearGateway();
		});
		if (typeof paydunyaPopWindows !== "undefined") {
			console.log(paydunyaPopWindows);
		}
	}, []);

	const selectGateway = (e) => {
		setGateway(e.target.value);
	};
	const handleMobilePayment = async (e) => {
		e.preventDefault();

		let data = {
			gateway: gateway,
			phone: phonenumber,
			reference: referenceGenerator(phonenumber.substring(1).replace(/\s/g, "")),
		};
		console.log(data)
		if (user.discount > 0) {
			data.discount = 0.2;
		}
		if (data.gateway !== "PAYDUNYA") {
			clearGateway();
			closeModal();
			showInfoMessage(`Sorry this payment system is not yet available`);
		} else {
			console.log(data);

			try {
				closeModal();
				setShowLoader(true);
				const res = await axios.post("/subscription/mmo", data);

				console.log(res.data);

				localStorage.setItem("transaction_id", res.data.transaction_id);
				window.open(
					res.data
						.checkoutUrl /*,
					"popUpWindow",
					"height=500,width=500,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,directories=no, status=yes"*/
				);
				/*paydunyaPopWindows.focus()
				const cancelUrl = `${process.env.REACT_APP_BACKEND_SERVER}/api/v1/paydunyaCancel`;
				paydunyaPopWindows.document.body.appendChild(`<script type='text/javascript'>
				console.log('heloo')
				alert('hello')
				</script>`); */
				//console.log(typeof paydunyaPopWindows);
			} catch (error) {
				console.log(error);
				setShowLoader(false);
			}
		}
	};
	const searchGateway = async (e) => {
		e.preventDefault();
		getGateway(phonenumber);
	};

	return (
		<>
			{showLoader && (
				<OverlayLoader
					counterDelay={2000}
					sentences={[
						`
					Please wait a bit `,
						`This may take 1 to 2 minutes`,
					]}
					fadeIn={true}
				/>
			)}
			<Modal isOpen={activeModal === "CardModal"} onRequestClose={closeModal} style={modalStylesReset}>
				{/* // <Modal isOpen={true} onRequestClose={closeModal} style={modalStylesReset}> */}
				<div className="modal__content modal--card container--default d-flex flex-column justify-content-center p-3 p-md-4">
					<button className="btn btn--empty modal__close p-4" onClick={closeModal}>
						<img src={icon_close__white} alt="" />
					</button>
					<Tabs>
						<TabList>
							<div className="d-flex justify-content-center pt-5 mt-3">
								<Tab className="tab-btn py-2 px-4">
									<b>Card</b>
								</Tab>
								<Tab className="tab-btn py-2 px-4 ml-4">
									<b>Mobile money</b>
								</Tab>
							</div>
						</TabList>
						<TabPanel>
							<form onSubmit={handleFormSubmit} className="pt-2">
								<div>
									<div className="input__field mt-3">
										<label htmlFor="cc-number" className="input__label">
											Card number
										</label>
										<div className="input__group">
											<InputMask
												type="text"
												mask="9999 9999 9999 9999"
												name="number"
												value={number}
												autoComplete="cc-number"
												placeholder="Visa, MasterCard, AE"
												className="input input--primary input--with_icon"
												onChange={handleCardDataChange}
												required
											/>
											<div className="input__icon">
												<img src={icon_card} alt="" />
											</div>
										</div>
									</div>
									<div className="d-flex mt-3">
										<div className="input__field w-100">
											<label htmlFor="expires" className="input__label">
												Expires
											</label>
											<div className="input__group">
												<InputMask
													mask="99/99"
													type="text"
													name="expires"
													value={expires}
													autoComplete="cc-exp"
													placeholder="mm/yy"
													className="input input--primary input--with_icon"
													onChange={handleCardDataChange}
													required
												/>
												<div className="input__icon">
													<img src={icon_calendar} alt="" />
												</div>
											</div>
										</div>
										<div className="input__field w-100 ml-3">
											<label htmlFor="cc-cvc" className="input__label">
												CVC
											</label>
											<div className="input__group">
												<InputMask
													type="text"
													mask="999"
													name="cvc"
													value={cvc}
													autoComplete="cc-csc"
													placeholder="3 digits"
													className="input input--primary input--with_icon"
													onChange={handleCardDataChange}
													required
												/>
												<div className="input__icon">
													<img src={icon_lock__white} alt="" />
												</div>
											</div>
										</div>
									</div>
									<div className="input__field mt-3">
										<label htmlFor="cc-name" className="input__label">
											Holder's name
										</label>
										<div className="input__group">
											<input
												type="text"
												name="cc-name"
												autoComplete="cc-name"
												placeholder="Holder's full name"
												className="input input--primary input--with_icon"
											/>
											<div className="input__icon">
												<img src={icon_user__white} alt="" />
											</div>
										</div>
									</div>

									<div className="d-flex flex-column align-items-center justify-content-center mt-5 pb-5">
										{card ? (
											<Fragment>
												<button className="btn btn--white w-100" type="submit">
													{isValid ? "Save" : "Buy subscription"}
												</button>
											</Fragment>
										) : (
											<button className="btn btn--white justify-content-between w-100" type="submit">
												Buy subscription
												{user?.discount && user.discount > 0 ? (
													<span>
														<s className="opacity--05 pr-2">$20</s>
														$16
													</span>
												) : (
													<span>$20</span>
												)}
											</button>
										)}
										{card && (
											<button
												className="btn btn--empty w-100 mt-3"
												onClick={() => {
													setActiveModal("DeleteCardModal");
												}}
											>
												Delete my card
											</button>
										)}
										{user.discount > 0 && <p className="pt-3 fz--18 fw--600">You have 20% discount</p>}
									</div>
								</div>
							</form>
						</TabPanel>
						<TabPanel>
							<form
								className="pt-2"
								onSubmit={gateways !== null && gateways.length > 0 ? handleMobilePayment : searchGateway}
							>
								<p className="text-center mt-3 fw--500">
									You can pay for your subscription with mobile money. May not be available in all countries
								</p>
								<div>
									{gateways !== null && gateways.length > 0 ? (
										<>
											{" "}
											<div className="input__field mt-3">
												<label htmlFor="cc-name" className="input__label">
													Carrier
												</label>
												<div className="input__group">
													<select className="select select--primary" onChange={selectGateway} value={gateway} required >
													<option>SELECT GATEWAY</option>
														{gateways.map((gateway, index) => (
															<option key={index}>{gateway.operator}</option>
														))}
													</select>
												</div>
											</div>
											<div className="d-flex flex-column align-items-center justify-content-center mt-5 pb-5">
												{/*<button className="btn btn--white justify-content-between w-100" type="submit">
											Buy subscription
											{user?.discount && user.discount > 0 ? (
												<span>
													<s className="opacity--05 pr-2">$20</s>
													$18
												</span>
											) : (
												<span>$20</span>
											)}
											</button>*/}
												<button className="btn btn--white justify-content-center w-100" type="submit">
													Proceed to payment
												</button>

												{user.discount > 0 && <p className="pt-3 fz--18 fw--600">You have 20% discount</p>}
											</div>
										</>
									) : (
										<>
											<div className="input__field mt-3 ">
												<label htmlFor="cc-phone" className="input__label">
													Country and Phone number
												</label>
												<PhoneInput
													inputClass="input input--primary input--phoneInput"
													inputProps={{
														name: "phone",
														required: true,
														autoFocus: true,
													}}
													placeholder="Phonenumber"
													country={"tg"}
													regions={"africa"}
													isValid={(inputNumber, country, countries) => {
														return countries.some((country) => {
															return (
																startsWith(inputNumber, country.dialCode) || startsWith(country.dialCode, inputNumber)
															);
														});
													}}
													dropdownStyle={{ color: "black" }}
													inputStyle={{ color: "white", borderColor: "white" }}
													containerStyle={{ borderColor: "white" }}
													onChange={(value, countryName, e, formattedValue) => {
														setPhonenumber(formattedValue);
														console.log(countryName.countryCode.toUpperCase());
													}}
												/>
											</div>
											<div className="d-flex flex-column align-items-center justify-content-center mt-5 pb-5">
												{/*<button className="btn btn--white justify-content-between w-100" type="submit">
											Buy subscription
											{user?.discount && user.discount > 0 ? (
												<span>
													<s className="opacity--05 pr-2">$20</s>
													$18
												</span>
											) : (
												<span>$20</span>
											)}
											</button>*/}
												<button className="btn btn--white justify-content-center w-100" type="submit">
													Next
												</button>

												{user.discount > 0 && <p className="pt-3 fz--18 fw--600">You have 20% discount</p>}
											</div>
										</>
									)}
									{/*	<div className="input__field mt-3">
										<label htmlFor="cc-name" className="input__label">
											Carrier
										</label>
										<div className="input__group">
											<select className="select select--primary">
												<option selected>AT&T</option>
												<option>Carrier 2</option>
												<option>Carrier 3</option>
											</select>
										</div>
										</div>*/}
								</div>
							</form>
						</TabPanel>
					</Tabs>
				</div>
			</Modal>
		</>
	);
};

export default CardModal;
